// ABOUTME: Stimulus controller para adicionar/remover filtros dinâmicos.
// ABOUTME: Recebe campos e operadores via values, clona template para cada filtro.

import { Controller } from "@hotwired/stimulus"

const OPERATOR_LABELS = {
  eq: "igual a",
  in: "em",
  gt: "maior que",
  gte: "maior ou igual a",
  lt: "menor que",
  lte: "menor ou igual a",
  between: "entre",
  contains: "contém",
  starts_with: "começa com"
}

const VALUE_MASKS = {
  integer: "positive-integer"
}

export default class extends Controller {
  static targets = ["template", "container"]
  static values = { operators: Object, fields: Array }

  #filterCount = 0

  connect() {
    this.#filterCount = this.containerTarget.querySelectorAll("[data-filter-row]").length
  }

  add(event) {
    event.preventDefault()
    const template = this.templateTarget.content.cloneNode(true)

    this.#populateFieldOptions(template)

    const index = this.#filterCount++
    template.querySelectorAll("[name]").forEach(el => {
      el.name = el.name.replace("filters[]", `filters[${index}]`)
    })

    this.containerTarget.appendChild(template)
  }

  fieldChanged(event) {
    const row = event.target.closest("[data-filter-row]")
    /* v8 ignore next */
    if (!row) return

    const operatorSelect = row.querySelector("[data-filter-operator]")
    /* v8 ignore next */
    if (!operatorSelect) return

    /* v8 ignore next 2 */
    const fieldType = event.target.selectedOptions[0]?.dataset?.type
    const operators = this.operatorsValue[fieldType] || []

    operatorSelect.replaceChildren()
    operators.forEach(op => {
      const option = document.createElement("option")
      option.value = op
      /* v8 ignore next */
      option.textContent = OPERATOR_LABELS[op] || op
      operatorSelect.appendChild(option)
    })

    this.#applyValueMask(row, fieldType)
  }

  // Troca o campo de valor por um novo porque o controller de máscara do @uenf/layout
  // só lê o tipo da máscara no connect.
  #applyValueMask(row, fieldType) {
    const current = row.querySelector("[data-filter-value]")
    /* v8 ignore next */
    if (!current) return

    const input = document.createElement("input")
    input.type = "text"
    input.name = current.name
    input.className = current.className
    input.dataset.filterValue = ""

    let replacement = input
    const maskType = VALUE_MASKS[fieldType]
    if (maskType) {
      replacement = document.createElement("div")
      replacement.dataset.controller = "mask"
      replacement.dataset.maskType = maskType
      input.dataset.maskTarget = "input"
      replacement.appendChild(input)
    }

    const previous = current.closest('[data-controller="mask"]') || current
    previous.replaceWith(replacement)
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-filter-row]").remove()
  }

  #populateFieldOptions(template) {
    const fieldSelect = template.querySelector("[data-filter-field]")
    /* v8 ignore next */
    if (!fieldSelect) return

    fieldSelect.replaceChildren()

    const blank = document.createElement("option")
    blank.value = ""
    blank.textContent = "Selecione..."
    fieldSelect.appendChild(blank)

    this.fieldsValue.forEach(f => {
      const option = document.createElement("option")
      option.value = f.name
      option.textContent = f.label
      /* v8 ignore next */
      option.dataset.type = f.type || "string"
      fieldSelect.appendChild(option)
    })
  }
}
